module.exports = __webpack_public_path__ + "static/media/terror-016.e1328545.e1328545.jpg";